import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Wrapper, Container, ButtonContainer, TextContainer } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { AvatarWithLabel } from '../../dataDisplay/AvatarWithLabel/AvatarWithLabel.js';
import { Typography } from '../../foundation/Typography/styled.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function AlertTitle(props) {
  var icon = props.icon,
    appearance = props.appearance,
    title = props.title,
    message = props.message;
  if (icon) {
    return /*#__PURE__*/jsx(AvatarWithLabel, {
      size: "xl",
      shape: "square",
      appearance: appearance,
      title: title,
      subtitle: message,
      truncate: false,
      children: icon
    });
  }
  return /*#__PURE__*/jsxs(TextContainer, {
    children: [/*#__PURE__*/jsx(Typography, {
      $fontWeight: "medium",
      $fontSize: "huge",
      $appearance: "300",
      children: title
    }), /*#__PURE__*/jsx(Typography, {
      $fontWeight: "regular",
      $fontSize: "small",
      $appearance: "200",
      children: message
    })]
  });
}
function Alert(props) {
  var appearance = props.appearance,
    pale = props.pale,
    children = props.children,
    icon = props.icon,
    message = props.message,
    title = props.title,
    rest = __rest(props, ["appearance", "pale", "children", "icon", "message", "title"]);
  return /*#__PURE__*/jsx(Wrapper, {
    $appearance: appearance,
    children: /*#__PURE__*/jsxs(Container, _extends({
      role: "alert",
      $pale: pale,
      $appearance: appearance
    }, rest, {
      children: [/*#__PURE__*/jsx(AlertTitle, {
        appearance: appearance,
        icon: icon,
        title: title,
        message: message
      }), children && /*#__PURE__*/jsx(ButtonContainer, {
        children: children
      })]
    }))
  });
}

export { Alert };
